import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * Bottom tab bar for phone-sized viewports (< lg).
 *
 * Positioned with `bottom: 0` + inner padding that respects
 * `env(safe-area-inset-bottom)` so it clears the iOS home indicator and the
 * dynamic Safari toolbar. Touch targets are 56px+ tall (Apple HIG minimum
 * is 44pt; we go bigger for gloves + shaky hands).
 */
export default function MobileTabBar({ navItems }) {
  if (!navItems?.length) return null;
  return (
    <nav
      data-testid="mobile-tab-bar"
      aria-label="Primary"
      className="lg:hidden fixed inset-x-0 bottom-0 z-50 bg-white border-t border-gray-200 shadow-[0_-2px_16px_rgba(0,0,0,0.04)]"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 6px)" }}
    >
      <ul
        className="grid"
        style={{ gridTemplateColumns: `repeat(${navItems.length}, minmax(0, 1fr))` }}
      >
        {navItems.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              data-testid={`tab-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center justify-center gap-1 min-h-[56px] px-1 py-2 text-[10px] font-mono tracking-[0.14em] uppercase transition-colors touch-manipulation",
                  isActive ? "text-[#0a0a0a]" : "text-gray-400 active:text-[#0a0a0a] hover:text-[#0a0a0a]"
                )
              }
            >
              {({ isActive }) => (
                <>
                  <item.icon className={cn("h-5 w-5 shrink-0", isActive ? "text-orange-500" : "text-gray-500")} />
                  <span className="truncate max-w-full leading-tight">{item.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
